import {NamaPresenter} from "./NamaPresenter";
import * as CommonConstants from "../constants/CommonConstants";
import * as PlaceTokens from "../constants/PlaceTokens";
import * as placeTokens from "../constants/PlaceTokens";
import * as Translator from "../common/Translator";
import {translateNaMaText} from "../common/Translator";

import {currentTimeMillis, getCustomGUISettings} from "../login/ClientCache";
import {ReportViewer} from "../views/ReportViewer";
import {NamaRouterInstance} from "./NamaRouter";
import * as places from "./places";
import {getDirectPrintOption, printNext} from "../common/NaMaPrinting";
import * as errors from "../common/ErrorsNotification";
import * as cmn from "../common/NamaCommon";
import {ReportLauncherPresenter} from "./ReportLauncherPresenter";
import * as NamaURLS from "../constants/NamaURLS";

export class ReportViewerPresenter extends NamaPresenter {
    start() {
        let that = this;
        let place = that.place;
        let request = {
            questions: place.questions,
            reportId: place.reportId,
            outputFormat: place.format,
            printingOption: place.printingOption,
            downloadPurpose: place.purpose,
            isForm: false,
            lang: Translator.currentLanguage()
        };
        cmn.ajaxJSON(NamaURLS.RunReport, {
            request: JSON.stringify(request)
        }, (result) => {
            if (result.list) {
                that.tempPrintId = result.list[0].tempPrintId;
                that.rptUrl = reportUrl(place.reportId, that.tempPrintId, null, place.format, place.printingOption, place.purpose,
                    place.reportId);
                that.view = new ReportViewer(that);
                that.view.render();
            }
        });
    }


    relaunchReport() {
        let that = this;
        let place = that.place;
        if (!place.embeddedReportView && !that.embeddedReportView) {
            let launcherPlace = new places.ReportLauncherPlace();
            launcherPlace.reportId = place.reportId;
            launcherPlace.questions = place.questions;
            NamaRouterInstance.goTo(launcherPlace);
        }
        else {
            let reportPresenter = new ReportLauncherPresenter(place);
            reportPresenter.embeddedReportView = true;
            let repContainer = that.reportContainer || that.embeddedViewContainer;
            repContainer.html("");
            reportPresenter.reportContainer = repContainer;
            reportPresenter.viewHeight = that.viewHeight;
            reportPresenter.viewWidth = that.viewWidth;
            reportPresenter.start();
        }
    }

    fetchTempPrintId(url) {
        let urlParams = cmn.substringAfter(url, "?");
        let keyValuePairs = urlParams.split(placeTokens.PARAMETERS_SEPERATOR);
        for (let keyValuePair of keyValuePairs) {
            let parts = keyValuePair.split("=");
            if (parts[0] === placeTokens.PRM_TEMP_PRINT_ID)
                return parts[1];
        }
        return "";
    }

    onExport(format, downloadPurpose) {
        let that = this;
        let place = that.place;
        let location = that.view.find("#reportIFrame")[0].contentWindow.location;
        place.tempPrintId = that.tempPrintId;
        if (!that.tempPrintId) {
            errors.showErrors(translateNaMaText("youDoNotHaveAdobeReaderPlugin"));
            return;
        }
        let url = reportUrl(place.reportId, that.tempPrintId, null, format, getDirectPrintOption(), downloadPurpose);
        printNext([url], 0);
    }

    onRefresh() {
        this.relaunchReport();
    }

}

export function reportUrl(reportId, tempPrintId, questions, format, printingOption, purpose) {
    let url = CommonConstants.RUN_REPORT_SERVLET + requestParam(PlaceTokens.PRM_QUESTIONS, questions)
        + requestParam(PlaceTokens.PRM_OUTPUT_FORMAT, format) + requestParam(PlaceTokens.PRM_ID, reportId)
        + requestParam(PlaceTokens.PRM_PRINTING_OPTION, printingOption) + requestParam(PlaceTokens.PRM_DOWNLOAD_PURPOSE, purpose)
        + requestParam(PlaceTokens.PRM_TEMP_PRINT_ID, tempPrintId) + requestParam("timeStamp", currentTimeMillis())
        + requestParam(PlaceTokens.PRM_LANGUAGE, Translator.locale);
    if (getCustomGUISettings().openPrintInBrowserWindow)
        url += requestParam("newP", "yesToNewPNama");
    return url;
}

export function requestParam(name, value) {
    if (value || value === false)
        return name + "=" + value + "&";
    return "";
}
